module.exports = __webpack_public_path__ + "theme/assets/img/7741d49fa1e86866f84e6efbc009da46.png";